/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {useEffect} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Navbar} from './Navbar'

const pageTitles: Array<{prefix: string; title: string; description: string}> = [
  {prefix: '/dashboard', title: 'Dashboard', description: 'Network overview'},
  {prefix: '/business-matrix', title: 'Business Matrix', description: 'Growth and retention'},
  {prefix: '/user-management', title: 'Users', description: 'Members and profiles'},
  {prefix: '/trip-management', title: 'Trips', description: 'Ride operations'},
  {prefix: '/gift-card-management', title: 'Gift Cards', description: 'Rewards and redemptions'},
  {prefix: '/mates-management', title: 'Mates', description: 'Community connections'},
  {prefix: '/wallet-management', title: 'Wallet', description: 'Credits and transactions'},
  {prefix: '/payment', title: 'Payments', description: 'Purchases and billing'},
  {prefix: '/platform-pricing', title: 'Platform Pricing', description: 'Driver suggested fares'},
  {prefix: '/feedback-response', title: 'Feedback Response', description: 'Customer sentiment'},
  {prefix: '/admin-users', title: 'Admin Users', description: 'Back-office accounts'},
  {prefix: '/settings/roles', title: 'Roles & Permissions', description: 'Access control'},
  {prefix: '/audit-logs', title: 'Audit Logs', description: 'Security activity'},
]

export function HeaderWrapper() {
  const {config, classes} = useLayout()
  const {pathname} = useLocation()
  const activePage =
    pageTitles
      .filter((item) => pathname.startsWith(item.prefix))
      .sort((a, b) => b.prefix.length - a.prefix.length)[0] ?? pageTitles[0]

  useEffect(() => {
    if (config.app?.header?.default?.fixed?.desktop) {
      document.body.setAttribute('data-kt-app-header-fixed', 'true')
    } else {
      document.body.removeAttribute('data-kt-app-header-fixed')
    }

    if (config.app?.header?.default?.fixed?.mobile) {
      document.body.setAttribute('data-kt-app-header-fixed-mobile', 'true')
    } else {
      document.body.removeAttribute('data-kt-app-header-fixed-mobile')
    }
  }, [config])

  if (!config.app?.header?.display) {
    return null
  }

  return (
    <div
      id='kt_app_header'
      className='app-header border-bottom border-gray-200 bg-body shadow-sm'
    >
      <div
        id='kt_app_header_container'
        className={clsx(
          'app-container flex-lg-grow-1',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
      >
        {config.app.sidebar?.display && (
          <>
            <div
              className='d-flex align-items-center d-lg-none ms-n2 me-3'
              title='Show sidebar menu'
            >
              <div
                className='btn btn-icon btn-light-primary w-38px h-38px'
                id='kt_app_sidebar_mobile_toggle'
              >
                <KTIcon iconName='abstract-14' className='fs-1' />
              </div>
              <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                <Link to='/dashboard' className='d-lg-none'>
                  <img alt='Logo' src={toAbsoluteUrl('/media/logo.svg')} className='h-30px' />
                </Link>
              </div>
            </div>
          </>
        )}

        {!(config.layoutType === 'dark-sidebar' || config.layoutType === 'light-sidebar') && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
            <Link to='/dashboard'>
              {config.layoutType !== 'dark-header' ? (
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('/media/logo.svg')}
                  className='h-20px h-lg-30px app-sidebar-logo-default'
                />
              ) : (
                <>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logo.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-light-show'
                  />
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logo.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-dark-show'
                  />
                </>
              )}
            </Link>
          </div>
        )}

        <div
          id='kt_app_header_wrapper'
          className='d-flex align-items-stretch justify-content-between flex-lg-grow-1 gap-3 gap-lg-6'
        >
          {config.app.header.default?.content === 'menu' &&
            config.app.header.default.menu?.display && (
              <div
                className='app-header-menu app-header-mobile-drawer align-items-stretch'
                data-kt-drawer='true'
                data-kt-drawer-name='app-header-menu'
                data-kt-drawer-activate='{default: true, lg: false}'
                data-kt-drawer-overlay='true'
                data-kt-drawer-width='225px'
                data-kt-drawer-direction='end'
                data-kt-drawer-toggle='#kt_app_header_menu_toggle'
                data-kt-swapper='true'
                data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
              >
                <div className='d-flex align-items-center h-100'>
                  <div className='d-flex align-items-center gap-3'>
                    <span className='symbol symbol-40px bg-light-primary'>
                      <span className='symbol-label bg-light-primary'>
                        <KTIcon iconName='category' className='fs-2 text-primary' />
                      </span>
                    </span>
                    <div className='d-flex flex-column'>
                      <span className='fw-bold text-gray-900 fs-5'>{activePage.title}</span>
                      <span className='text-muted fs-8 fw-semibold'>{activePage.description}</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          <Navbar />
        </div>
      </div>
    </div>
  )
}
